/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The DXP main navigation data id.
 */
export const DXP_DATA_ID_MAIN_NAVIGATION = `Side Navigation Menu`;

/**
 * The DXP dialog data id.
 */
export const DXP_DATA_ID_DIALOG = `DXP Dialog`;

/**
 * The DXP mobile toolbar button data id.
 */
export const DXP_DATA_ID_TOOLBAR_BUTTON = `Toolbar: expand and collapse button`;

/**
 * The DXP form error data id.
 */
export const DXP_DATA_ID_FORM_ERROR = `Form: Form error message`;
